import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { AdminProductService } from '@services/admin-product.service';
import * as AdminProductsActions from './admin-products.actions';

@Injectable()
export class AdminProductsEffects {
  private readonly actions$ = inject(Actions);
  private readonly adminProductService = inject(AdminProductService);

  loadAdminProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminProductsActions.loadAdminProducts),
      exhaustMap(action =>
        this.adminProductService.getProducts(action.page, action.size).pipe(
          map(productResponse => AdminProductsActions.loadAdminProductsSuccess({ productResponse })),
          catchError(error => of(AdminProductsActions.loadAdminProductsFailure({ error })))
        )
      )
    )
  );
}
